import * as t from 'io-ts';

import {makeApiType} from './apiTypes';
import {parseIncident, RIncident} from './incidentModel';

/*
 * Runtime types.
 */

const RIncidentPageDirty = t.readonlyArray(RIncident);

/*
 * Type.
 */

export interface IncidentPageModel extends t.TypeOf<typeof RIncidentPageDirty> {}
export const RIncidentPage = t.clean<IncidentPageModel>(RIncidentPageDirty as any);

/*
 * IO methods.
 */

export function parseIncidentPage(src: any): IncidentPageModel {
  return src && src.incidents && src.incidents.map(parseIncident);
}

/*
 * API type.
 */

export const ApiIncidentPage = makeApiType('incidentPage', RIncidentPage, parseIncidentPage);
